export const types = {
  M_ADD_FLOW_ITEM: "M_ADD_FLOW_ITEM",
  M_REMOVE_FLOW_ITEM: "M_REMOVE_FLOW_ITEM",
  M_CLEAR_FLOW: "M_CLEAR_FLOW"
};

export const mutations = {
  [types.M_ADD_FLOW_ITEM]: (state, item) => {
    state.flow.push(item);
  },
  [types.M_REMOVE_FLOW_ITEM]: (state, uuid) => {
    state.flow = state.flow.filter(a => a.uuid !== uuid);
  },
  [types.M_CLEAR_FLOW]: state => {
    state.flow = [];
  }
};
